import { render, staticRenderFns } from "./IristarPartner.vue?vue&type=template&id=ad4d5d70&"
import script from "./IristarPartner.vue?vue&type=script&lang=js&"
export * from "./IristarPartner.vue?vue&type=script&lang=js&"
import style0 from "./IristarPartner.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports